export default () => {
	// if (window.location.host.indexOf("localhost") !== -1) {
	// 	return "https://api-staging.whistleblowing-compliant.eu/api";
	// }
	// if (window.location.host.indexOf("staging") !== -1) {
	// 	return "https://api-staging.whistleblowing-compliant.eu/api";
	// }
	return "https://api-staging.whistleblowing-compliant.eu/api";
};
